import { render, staticRenderFns } from "./AdvertiserPanelBanner.vue?vue&type=template&id=b8562b9c&"
import script from "./AdvertiserPanelBanner.vue?vue&type=script&lang=js&"
export * from "./AdvertiserPanelBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports